import { EvaluationColor } from '@repo/types';
import c from 'classnames';
import styles from './RangeSegment.module.css';
import { calculateLeft, PreparedRange } from './utils';

type Props = {
  range: PreparedRange;
  showValue: boolean;
  valueDisplay?: string;
  valueMarkerColor: EvaluationColor;
  isFirst: boolean;
  isLast: boolean;
  variant?: 'default' | 'result';
};

export default function RangeSegment({
  range,
  showValue,
  valueDisplay,
  valueMarkerColor,
  isFirst,
  isLast,
  variant = 'default',
}: Props) {
  const { breakpointLabel, isSampleRange, samplePosition } = range;
  const markerStyle = { left: calculateLeft(isFirst, isLast, samplePosition) };
  const isResult = variant === 'result';

  const segmentColorClass: Record<EvaluationColor, string> = {
    green: styles.segGreen,
    grey: styles.segGrey,
    orange: styles.segOrange,
    red: styles.segRed,
  };

  return (
    <div
      className={styles.barBlock}
      style={{ flexBasis: `${range.percentage}%` }}
    >
      <div>
        <div
          className={c(
            styles.bar,
            isResult && styles.barResult,
            isResult && segmentColorClass[range.evaluation_color],
            isFirst && styles.first,
            isLast && styles.last,
          )}
        >
          {isSampleRange && showValue && (
            <>
              {valueDisplay && (
                <span
                  className={c(
                    isResult ? styles.valuePlain : styles.valueAboveMarker,
                    !isResult && styles[valueMarkerColor],
                  )}
                  style={markerStyle}
                >
                  {valueDisplay}
                </span>
              )}
              <span
                className={styles.triangleMarker}
                style={{ left: `${samplePosition}%` }}
              />
            </>
          )}
        </div>
      </div>
      {!isResult && (
        <div className={c(styles.details, 'flexStart', 'mb-auto')}>
          {breakpointLabel && (
            <span className={c(styles.breakpoint, 'mt-auto')}>
              {breakpointLabel}
            </span>
          )}
        </div>
      )}
      {!isResult && !isLast ? <span className={styles.divider} /> : null}
    </div>
  );
}
